import React, { useState, Suspense, lazy } from "react";
import exportToHTML from "./exportToHTML";
import { HandEyeIcon, FoldersIcon, XCircleIcon } from "@phosphor-icons/react";

function ProfileContent({ id, modalId, content }) {
  const [isVisible, setIsVisible] = useState(true);
  const [isMaximized, setIsMaximized] = useState(false);

  const closeMenu = (e) => {
    const details = e.target.closest("details");
    if (details) details.open = false;
  };

  const handleExport = (e) => {
    exportToHTML(modalId);
    closeMenu(e);
  };

  const handleClose = (e) => {
    document.getElementById(modalId)?.remove();
    closeMenu(e);
  };

  const handleToggleVisibility = (e) => {
    setIsVisible((v) => !v);
    closeMenu(e);
  };

  const handleToggleMaximize = (e) => {
    setIsMaximized((m) => !m);
    document.getElementById("modal_" + modalId).style.top = 0; // Reset scroll position
    document.getElementById("modal_" + modalId).style.left = 0; // Reset scroll position
    closeMenu(e);
  };

  return (
    <div
      id={"modal_" + modalId}   // ✅ add this
      key={'modal_' + modalId}
      className="mx-auto"
      style={{
        top: isMaximized ? "-32px" : "0px",
        left: isMaximized ? "-9%" : "0px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: isMaximized ? "100vw" : "100%",
        height: isMaximized ? "100vh" : "100%",   // fixed height
        position: "absolute",
        margin: "0 auto",
        backgroundColor: "#101010",
        zIndex: isMaximized ? 1000 : "auto",
        borderRadius: "5px",
        padding: 0,
        overflow: "hidden",                       // hide outside overflow
      }}
    >
      {/* header stays fixed */}
      <div
        className="modal-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "8px",
          minHeight: "40px",
          cursor: "grab",
          background: "#181818",
          borderBottom: "1px solid #2a2a2a",
          borderTopLeftRadius: "5px",
          borderTopRightRadius: "5px",
          flexShrink: 0,                           // keep header visible
        }}
      >

        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          {/* File menu */}
          <div style={{ position: "relative" }}>
            <summary style={{ cursor: "pointer" }}>{id}</summary>
          </div>
          <details style={{ position: "relative" }}>
            <summary style={{ cursor: "pointer" }}><FoldersIcon size={24} weight="fill" /> File</summary>
            <ul
              style={{
                color: "white",
                listStyle: "none",
                margin: 0,
                padding: "8px",
                position: "absolute",
                top: "100%",
                left: 0,
                background: "rgba(0, 0, 0, .65)",
                border: "1px solid #000",
                borderRadius: "10px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                whiteSpace: "nowrap",
                zIndex: 10,
              }}
            >
              <li>
                <button
                  style={{ display: "block", width: "100%" }}
                  onClick={handleExport}
                >
                  Export Data
                </button>
              </li>
              <li>
                <button
                  style={{ display: "block", width: "100%" }}
                  onClick={handleClose}
                >
                  Close
                </button>
              </li>
            </ul>
          </details>
  
          {/* View menu */}
          <details style={{ position: "relative" }}>
            <summary style={{ cursor: "pointer" }}><HandEyeIcon weight="fill" size={24} /> View</summary>
            <ul
              style={{
                listStyle: "none",
                marginTop: "10px",
                padding: "8px",
                position: "absolute",
                top: "100%",
                left: 0,
                background: "#000",
                border: "1px solid #ccc",
                borderRadius: "10px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                whiteSpace: "nowrap",
                zIndex: 10,
              }}
            >
              <li key={"toggle_visibility_" + modalId}>
                <button
                  style={{ display: "block", width: "100%" }}
                  onClick={handleToggleVisibility}
                >
                  {isVisible ? "Hide Content" : "Show Content"}
                </button>
              </li>
              <li key={"toggle_maximize" + modalId}>
                <button
                  style={{ display: "block", width: "100%" }}
                  onClick={handleToggleMaximize}
                >
                  {isMaximized ? "Restore Size" : "Maximize"}
                </button>
              </li>
            </ul>
          </details>
        </div>
                <button
          style={{ display: "block", float: "right", width: "50px" }}
          onClick={handleClose}
        >
          <XCircleIcon size={24} />
        </button>
      </div>
  
      {/* scrollable body */}
      <div
        id={modalId + "_content"}
        className="scrollable"
        style={{
          display: isVisible ? "block" : "none",
          width: "100%",
          flex: 1,                   // take up remaining space
          overflowY: "auto",         // ✅ enable scroll inside
          padding: "8px",
          scrollbarWidth: "revert",
        }}
      >
         <Suspense
          fallback={
            <div style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              background: "rgba(0,0,0,0.5)",
            }}>
              Loading content…
            </div>
          }
        >
          {content}
        </Suspense>
      </div>
    </div>
  );
  
}

export default ProfileContent;